import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-bike-popup',
  templateUrl: './bike-popup.component.html',
  styleUrls: ['./bike-popup.component.css']
})
export class BikePopupComponent implements OnInit {

  @Input() data;
  @Input() loaded;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/bike-popup/bike-popup.component.ts